<button
    [type]="type"
    class="btn"
    [title]="inputText | translate"
    [ngClass]="{ disabled: disabled }"
    [class]="classes"
    (click)="genericAction()"
>
    <span>{{ inputText | translate }}</span>
</button>
